// Kredi kartı Ödeme Yap penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.creditCardPayment';

export const creditCardPaymentGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kart borcu nasıl ödenir?'),
  intro: t(`${G}.intro`, 'Kredi kartı borcuna yaptığınız ödemeyi kaydeder; kartın borcu ödeme tutarı kadar azalır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Ödeme formu'),
    footer: t(`${G}.regions.footer`, 'Ödeme Yap'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Güncel borcu kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutuda kartın adı ve Güncel Borç görünür. Ödeme tutarı güncel borçtan fazla olamaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tutarı girin'),
      text: t(`${G}.s2.text`, 'Ödediğiniz tutarı sıfırdan büyük girin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tutarı binlik ayracı olmadan yazın; kuruş için virgül kullanın (ör. 2500,75).'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ödeme kaynağını seçin'),
      text: t(`${G}.s3.text`, 'Kasa veya Banka seçip hesabı belirleyin; listede yalnız kartla aynı para birimindeki hesaplar çıkar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kasa / Banka: tutar seçilen kasadan veya banka hesabından düşülür.'),
        t(`${G}.s3.tip2`, 'Tahakkuk (Elden): kasa / banka bakiyesi değişmez; sadece kart borcu düşer.'),
        t(`${G}.s3.tip3`, 'Şube yöneticisi yalnız kendi şubesinin kasa ve banka hesaplarını görür; Tahakkuk seçeneği ve proje alanı kapalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Tarih, proje ve açıklama'),
      text: t(`${G}.s4.text`, 'İşlem Tarihi varsayılan olarak bugündür. Proje seçerseniz borç ödemesi projede nakit çıkışı olarak görünür; maliyet kart harcamasında sayıldığı için ikinci kez maliyet yazılmaz. Açıklama boş bırakılırsa "Kredi kartı borç ödemesi" yazılır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Ödemeyi yapın'),
      text: t(`${G}.s5.text`, '"Ödeme Yap" sonrası kart borcu azalır ve hareket Kart Hareketleri listesinde "Ödeme" olarak görünür. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
